module.exports = __webpack_public_path__ + "img/pd-img-body8.db6a28a1.png";